import { colors, Grid, media, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

import { ModalEditableArea as ModalCitySelection } from 'templates/Category/containers/ModalCitySelection/styles';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${spacing.medium};
`;

export const LinkProxy = styled.a`
  text-decoration: none;
  display: block;
  // TODO: Add Variant to Pantheon
  > *::after {
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 35%,
      rgba(0, 0, 0, 0.35) 55%,
      rgba(0, 0, 0, 0.65) 70%,
      rgba(0, 0, 0, 0.85) 85%,
      rgba(0, 0, 0, 1) 100%
    );
  }
`;

interface SlideWrapperProps {
  haveContentBelow?: boolean;
}

// This is needed to compensate the position: absolute trails on slider
const sliderComplementSpacing = '2.4rem';

export const SlideWrapper = styled(Grid.Wrapper)<SlideWrapperProps>`
  ${({ haveContentBelow = false }) => css`
    margin-bottom: calc(
      ${sliderComplementSpacing} +
        ${haveContentBelow ? spacing.xlarge : spacing.large}
    );
    ${media.greaterThan('tablet')`
      margin-bottom: calc(
        ${sliderComplementSpacing} + ${
      haveContentBelow ? spacing.xxlarge : spacing.xlarge
    }
      );
    `};
  `};
  ${media.lessThan('tablet')`
    padding-right: 0;
    .slider-slide:last-of-type {
      ${LinkProxy} {
        margin-right: ${spacing.medium};
      }
    }
  `}
  ${ModalCitySelection} {
    padding-right: ${spacing.medium};
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  margin-bottom: calc(2rem + ${spacing.xxlarge});
  ${media.lessThan('tablet')`
    margin-bottom: ${spacing.xxlarge};
  `}
  ${ModalCitySelection} {
    padding-right: ${spacing.medium};
  }
`;

export const Badge = styled.div`
  position: absolute;
  transform: rotate(35deg);
  height: 3.4rem;
  width: 100%;
  background-color: ${colors.light};
  top: 2.8rem;
  left: 30%;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.greaterThan('tablet')`
    top: 2.5rem;
    left: 34%;
  `}
`;
